import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

const currentUserSelect = {
  User: [
    "contactId",
    "createdAt",
    "currentCountryId",
    "email",
    "firstName",
    "id",
    "identifiedRoles",
    "lastName",
    "name",
    "seenDashboardFirstVisitUpgradeOverlay",
    "unconfirmedEmail"
  ]
}

Devise.addUserScope("user", {
  query: User
    .ransack()
    .preload(["user_roles.role"])
    .select(currentUserSelect)
})
